/* قائمة الموبايل: تفتح وتسد بزر القائمة، وتسد عند الضغط على رابط أو Escape أو برا القائمة */
if (!customElements.get('hayat-header')) {
  customElements.define(
    'hayat-header',
    class HayatHeader extends HTMLElement {
      connectedCallback() {
        this.burger = this.querySelector('[data-hayat-burger]');
        this.nav = this.querySelector('[data-hayat-nav]');
        if (!this.burger || !this.nav) return;

        this.onKeydown = this.onKeydown.bind(this);
        this.onOutsideClick = this.onOutsideClick.bind(this);

        this.burger.addEventListener('click', () => this.toggle());
        this.nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
      }

      disconnectedCallback() {
        this.close();
      }

      toggle() {
        this.nav.classList.contains('is-open') ? this.close() : this.open();
      }

      open() {
        this.nav.classList.add('is-open');
        this.burger.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onOutsideClick);
      }

      close() {
        if (!this.nav) return;
        this.nav.classList.remove('is-open');
        this.burger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onOutsideClick);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        this.close();
        this.burger.focus();
      }

      onOutsideClick(event) {
        if (!this.contains(event.target)) this.close();
      }
    }
  );
}
